var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"lighten"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"100%","height":"60px","type":"card"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }